'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { Controller, useForm } from 'react-hook-form'
import { z } from 'zod'
import { cn, ToggleGroup, ToggleGroupItem } from '@nwwp/ui-shadcn'
import { funnelSchema } from '~/lib/schemas/funnel-schema'
import { useFunnelStore } from '../../_hooks/use-funnel-store'
import type { FunnelStepComponent } from '../../types'
import { FunnelStep } from '../FunnelStep'

const schema = funnelSchema.pick({ marital_status: true })
type Schema = z.infer<typeof schema>

const OPTIONS: Array<{ label: string; value: Schema['marital_status'] }> = [
  { label: 'Single', value: 'Single' },
  { label: 'Married', value: 'Married' },
  { label: 'Living together (Unmarried)', value: 'Life Partner' },
  { label: 'Divorced, separated, or widowed', value: 'Separated' },
]

export const MaritalStatus: FunnelStepComponent = ({ onSubmit }) => {
  const maritalStatus = useFunnelStore.getState().data.marital_status
  const { control, formState, handleSubmit } = useForm<Schema>({
    resolver: zodResolver(schema),
    defaultValues: { marital_status: maritalStatus },
    mode: 'onChange',
  })

  return (
    <FunnelStep onSubmit={handleSubmit(onSubmit)}>
      <FunnelStep.Title>What is your marital status?</FunnelStep.Title>
      <Controller
        name="marital_status"
        control={control}
        render={({ field }) => (
          <ToggleGroup
            type="single"
            value={field.value ?? ''}
            onValueChange={field.onChange}
            className="grid w-full grid-cols-1 gap-4 tablet:grid-cols-2"
            spacing={4}
          >
            {OPTIONS.map(({ label, value }) => (
              <ToggleGroupItem
                key={value}
                value={value ?? ''}
                className={cn(
                  'h-full max-w-120 justify-start rounded-4xl border border-neutral-dark bg-neutral-surface p-6 text-left [font-size:clamp(1.25rem,2vw,1.5rem)] [line-height:1.3] text-white data-[state=on]:border-green-lighter data-[state=on]:bg-neutral-surface data-[state=on]:text-white tablet:p-8'
                )}
              >
                {label}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        )}
      />
      <FunnelStep.Button disabled={!formState.isValid}>Next</FunnelStep.Button>
    </FunnelStep>
  )
}

MaritalStatus.path = 'marital-status'
MaritalStatus.schema = schema
MaritalStatus.pageActionSteps = ['marital_status']
